import { render, staticRenderFns } from "./Dialog.html?vue&type=template&id=4bfd7654&external"
import script from "./Dialog.js?vue&type=script&lang=js&external"
export * from "./Dialog.js?vue&type=script&lang=js&external"
import style0 from "./Dialog.scss?vue&type=style&index=0&prod&module=true&lang=scss&external"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports